import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	icon: {
		borderRadius: 2,
		width: theme.spacing(2),
		height: theme.spacing(2),
		...ColorUtil.getBackgroundAndContrastColor(colors.green[400]),
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.green[400]),
			opacity: 0.7
		},
		"& svg": {
			width: theme.spacing(2),
			height: theme.spacing(2)
		}
	},
	disabled: {
		...ColorUtil.getBackgroundAndContrastColor(`${colors.gray[100]} !important`)
	}
}))

export default useStyles
